import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { EAbsenceConclusionsListComponent } from './e-absence-conclusions-list/e-absence-conclusions-list.component';
import { EOthersListComponent } from './e-others-list/e-others-list.component';
import { AuthGuard } from '../core/authentication/auth.guard';
import { EDocumentBuforComponent } from './edocument-bufor/e-document-bufor.component';
import { EFoldersUcpListComponent } from './e-folders-ucp-list/e-folders-ucp-list.component';
import { EFoldersComponent } from './e-folders/e-folders.component';
import { SettingsComponent } from './settings/settings.component';

const routes: Routes = [
  {
    path: 'e-documentation',
    children: [
      {
        path: 'folders',
        component: EFoldersComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'absence-conclusions',
        component: EAbsenceConclusionsListComponent,
        canActivate: [AuthGuard]

      },
      {
        path: 'newdocs',
        component: EDocumentBuforComponent,
        canActivate: [AuthGuard]

      },
      {
        path: 'ucp',
        component: EFoldersUcpListComponent,
        canActivate: [AuthGuard]

      },
      {
        path: 'others',
        component: EOthersListComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'settings',
        component: SettingsComponent,
        canActivate: [AuthGuard]
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class EDocumentationRoutingModule { }
